import { SvgIcon, SxProps, Theme } from "@mui/material";

export function ListCheckIcon({ sx }: { sx: SxProps<Theme> & { color: string } }) {
  return (
    <SvgIcon sx={{ width: "19px", height: "18px", ...sx }} viewBox="0 0 19 18">
      <path d="M3.605 3.75h4.493v4.5H3.605v-4.5m1.497 1.5v1.5H6.6v-1.5H5.102m4.493 0h7.488v1.5H9.595v-1.5m0 6h7.488v1.5H9.595v-1.5M5.102 15l-2.62-2.625 1.055-1.057 1.565 1.56L8.54 9.442 9.595 10.5 5.102 15z" />
    </SvgIcon>
  );
}
